// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "Table__textCenter__bzIkB";
export const table = "Table__table__3Gf6k";
export const tableInner = "Table__tableInner__wepl7";
export const headerRow = "Table__headerRow__cohB+";
export const white = "Table__white__36zF2";
export const headerCell = "Table__headerCell__Iqfs+";
export const responsiveTitle = "Table__responsiveTitle__+Fa4t";
export const responsiveTitleText = "Table__responsiveTitleText__6olOd";
export const headerTitle = "Table__headerTitle__-6x6y";
export const sortingWrapper = "Table__sortingWrapper__5qiL2";
export const withHelpText = "Table__withHelpText__DNH2U";
export const up = "Table__up__d6Ana";
export const down = "Table__down__fOm+w";
export const body = "Table__body__ewFj7";
export const row = "Table__row__e8ZaR";
export const cell = "Table__cell__Hsww6";
export const footer = "Table__footer__+Akt4";
export const paginatorWrapper = "Table__paginatorWrapper__JqI85";
export const pageSizeSelectorWrapper = "Table__pageSizeSelectorWrapper__HzT-d";
export const tooltipIconWrapper = "Table__tooltipIconWrapper__YoKae";
export const debtsAccountDetails = "Table__debtsAccountDetails__KH65C";
export const creditAccountDetails = "Table__creditAccountDetails__Kxq2M";
export const accountsTable = "Table__accountsTable__QM8+T";
export const pointing = "Table__pointing__DgJGY";